import firebase from "firebase/app";
import Vue from "vue";
import { firebaseConfig, FIREBASE_PUBLIC_VAPID_KEY } from "@/api/config";
import "firebase/messaging";
firebase.initializeApp(firebaseConfig);
if (firebase.messaging.isSupported()) {
    window.firebaseMessaging = firebase.messaging();
    Vue.prototype.$messaging = firebase.messaging();
    Vue.prototype.$messaging.usePublicVapidKey(FIREBASE_PUBLIC_VAPID_KEY);
}
